import React from "react"

interface Props {
    title?: string
    waitTime?: number
    onNext: () => void
    onPageShown?: () => void
}

/**
 * This page is just to inform the user that the test is over.
 */
export default function TestOverPage(props: Props) {
    let {title="", waitTime=5000, onNext, onPageShown} = props

    if (onPageShown) {
        // Signal the parent that this page will be rendered!
        onPageShown() 
    }

    return (
        <>
            <div className="page-msg-fullscreen page--ptThankYou">
                <div className="container w-100 mx-auto">
                    <div className="row justify-content-center">
                        <div className="col-12" style={{ maxWidth: '940px' }}>
                            <img
                                alt="Winward Academy"
                                className="mx-auto d-block mb-4"
                                src="/assets/images/logo.png"
                            />
                            <h1 className="page-title text-center w-100 d-block">
                                Practice {title} Is Over
                            </h1>
                            <div className="img-frame with-overlap">
                                <img
                                    alt="SAT"
                                    className="d-block mx-auto"
                                    width="505"
                                    height="311"
                                    src="/assets/images/dashboard/practice/laptop-complete-check-opt.png"
                                    decoding="async"
                                    loading="eager"
                                />
                            </div>
                            <div className="card-select with-overlap">
                                <div className="card-select--inner mx-auto">
                                    <h5 className="mb-4">
                                        All your work has been saved, and we are scoring it now.
                                    </h5>
                                    <div className="">
                                        <button onClick={onNext} className="btn btn--bg-white">
                                            View Score
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

